import { render, staticRenderFns } from "./offcourseManage.vue?vue&type=template&id=359ca608&"
import script from "./offcourseManage.vue?vue&type=script&lang=js&"
export * from "./offcourseManage.vue?vue&type=script&lang=js&"
import style0 from "./offcourseManage.vue?vue&type=style&index=0&id=359ca608&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports